import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import Popup from 'reactjs-popup'

import styles from './styles.module.scss'
import Icon from 'srcReact/components/icons/Icon'

const LogoutPopin = ({ showLogout, closeLogout, handleClick }) => {
  const { t } = useTranslation()

  return (
    <Popup
      modal
      open={showLogout}
      onClose={closeLogout}
      position='top center'
      overlayStyle={{ background: 'rgba(54, 73, 88, 0.4)', padding: '2rem 0', overflowY: 'scroll' }}
      contentStyle={{
        width: '95%',
        maxWidth: '500px',
        padding: '0px',
        borderRadius: '22px',
        boxShadow: '5px 2px 10px 0 rgba(14, 11, 40, 0.15)',
        background: 'white',
        border: 'none',
      }}>
      <div className={styles.logoutPopupWrapper}>
        <div className={`${styles.header}`}>
          <div className={styles.title}>{t('logout.title')}</div>
          <div onClick={closeLogout} role='button'>
            <Icon name='close24' styleModifier={styles.closeIcon} />
          </div>
        </div>
        <hr className={styles.divider} />
        <div className={styles.body}>
          <div className={styles.description}>{t('logout.description1')}</div>
          <div className={`${styles.description} ${styles.margin}`}>{t('logout.description2')}</div>
        </div>
        <div className={styles.footer}>
          <button className={styles.button} onClick={handleClick}>
            {t('logout.ok')}
          </button>
          <button className={`${styles.button} ${styles.cancel}`} onClick={closeLogout}>
            {t('logout.cancel')}
          </button>
        </div>
      </div>
    </Popup>
  )
}

LogoutPopin.propTypes = {
  showLogout: PropTypes.bool,
  closeLogout: PropTypes.func,
  handleClick: PropTypes.func,
}

export default LogoutPopin
